import React from 'react'
import { Box, Typography } from '@mui/material'

function AttributeContainer({attribute, value}) {
    return (
        <Box sx={{display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: '20px'}}>
            <Typography variant='body2' sx={{flexGrow: 1}} fontWeight={'500'}>{attribute} </Typography>
            <Typography variant='body2' sx={{marginLeft: '10px', cursor: 'pointer'}}>{value}</Typography>
        </Box>
    )
}

export default AttributeContainer